import api from './api';
import logger from '../utils/logger';

export interface PasswordStatus {
    force_password_change: boolean;
    user_id: string;
    email: string;
}

export interface PasswordChangeRequest {
    current_password: string;
    new_password: string;
    confirm_password: string;
}

export interface PasswordChangeResponse {
    message: string;
    force_password_change: boolean;
}

class PasswordService {
    async getPasswordStatus(): Promise<PasswordStatus> {
        logger.debug('[PasswordService] Checking password status');
        const response = await api.get<PasswordStatus>('/users/password-status');
        return response.data;
    }

    async changePassword(request: PasswordChangeRequest): Promise<PasswordChangeResponse> {
        const response = await api.post<PasswordChangeResponse>('/users/change-password', request);
        return response.data;
    }
}

export const passwordService = new PasswordService();
